import React from 'react'
import {createRoot} from 'react-dom/client'
import '@babel/polyfill'
import WrappedApp from './WrappedApp'

const container = document.getElementById('root')! // typescript non-null check
const root = createRoot(container)
root.render(<WrappedApp />)
